import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ButtonRounded from '@/components/Atoms/Buttons/ButtonRounded.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonRoundedRed',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ButtonRounded, { class: "bg-red-600 text-white px-2 z-9" }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    })
  ]))
}
}

})